import { z } from 'zod';

const configSchema = z.object({
  VITE_GRAPHQL_URL: z.string(),
  VITE_ROLLBAR_TOKEN: z.string().optional(),
  VITE_ZENDESK_KEY: z.string().optional(),
  VITE_MANAGER_URL: z.string(),
  VITE_MANAGER_API_URL: z.string(),
  VITE_VERSION: z.string(),
  MODE: z.string(),
  PROD: z.boolean(),
  DEV: z.boolean(),
  VITE_POSTHOG_KEY: z.string(),
  VITE_POSTHOG_API: z.string(),
  VITE_POSTHOG_UI: z.string(),
});

type Config = z.infer<typeof configSchema>;

export const config: Config = configSchema.parse(import.meta.env);
